const awsmobile = {
    "aws_env": "production",
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_appsync_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:5ff921ca-fc91-4e95-b285-ad1d79e92e69",
    "aws_cognito_domain": "auth.learnwith.ai",
    "aws_user_pools_id": "us-east-1_aDPC6WHl1",
    "aws_user_pools_web_client_id": "3n86afr001ql68umpp319pts4n",
    "aws_appsync_graphqlEndpoint": "https://wopirgliozbidi3hbg6ytb7qwi.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_apiKey": "da2-evc52nvf4zabjaoidivjftjz4y",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};
export default awsmobile;
//# sourceMappingURL=aws-exports.js.map